import React          from 'react';
import PropTypes      from 'prop-types';
import Flux           from "../../../flux/Flux";
import Block          from '../../Homepage/Block';
import ButtonRow      from '../../Homepage/Block/ButtonRow';
import Header         from '../../Homepage/Block/Header';
import Translations   from '../../../utils/Translations';
import TVSeriesGrid   from "../TVSeriesGrid";
import { trackClick } from '../../../utils/GAHelper';


class TVSeriesBlock extends React.Component {

	constructor(props) {
		super(props);

		this.state = {totalSeriesCount: Flux.TVSeries.getTVSeriesTotalCount() || 0};


		this.onTVSeriesDataChange = this.onTVSeriesDataChange.bind(this);
	}

	componentDidMount() {
		Flux.TVSeries.addTVSeriesDataChangeListener(this.onTVSeriesDataChange);
	}

	componentWillUnmount() {
		Flux.TVSeries.removeTVSeriesDataChangeListener(this.onTVSeriesDataChange);
	}

	onTVSeriesDataChange() {
		this.setState(() => ({totalSeriesCount: Flux.TVSeries.getTVSeriesTotalCount() || 0}));
	}

	render() {
		const Grid = this.props.grid;

		return (
			<Block className="tv-series" idName="tv-series-block">
				<Header
					title={this.props.title}
					count={this.state.totalSeriesCount}
					hasCount={!!this.props.countLabel}
					countLabel={this.props.countLabel}
					appendTitle={this.props.appendTitle}
					headlineType={this.props.headlineType}
				/>
				<Grid count={this.props.tileCount} isMobile={this.props.isMobile} lazyImageLoading={this.props.lazyImageLoading} />
				<ButtonRow
					cta={Translations.get('ShowAll')}
					link={this.props.link}
					callback={() => this.props.doGaTracking ? trackClick('tv', this.props.link) : null}
				/>
			</Block>
		);
	}
}

TVSeriesBlock.propTypes = {
	isMobile:         PropTypes.bool.isRequired,
	link:             PropTypes.string.isRequired,
	title:            PropTypes.string.isRequired,
	appendTitle:      PropTypes.node,
	countLabel:       PropTypes.string,
	grid:             PropTypes.elementType,
	order:            PropTypes.string,
	tileCount:        PropTypes.number,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
	doGaTracking:     PropTypes.bool,
};

TVSeriesBlock.defaultProps = {
	countLabel:       Translations.get('TVAllSeriesHeadline'),
	grid:             TVSeriesGrid,
	isMobile:         false,
	tileCount:        10,
	title:            Translations.get('HomepageV2TVSeriesTitle'),
	lazyImageLoading: true,
	headlineType:     Flux.Constants.Headlines.h2,
	doGaTracking:     false,
};

export default TVSeriesBlock;
